import { GET_PARAMS } from "./paramHelper";
export const LOAD_CURRENT_USER = "LOAD_CURRENT_USER";

export const fetchCurrentUser = () => async dispatch => {
  const res = await fetch("/api/me", GET_PARAMS());

  // TODO: Add error handling if the user isn't found
  // Is this possible? Will it be possible with our new auth setup?
  const currentUser = await res.json();

  return dispatch({
    type: LOAD_CURRENT_USER,
    currentUser
  });
};
